module.exports = __webpack_public_path__ + "img/trz.0bb2392d.svg";